import { render, staticRenderFns } from "./wuHuoQuanTiHuo.vue?vue&type=template&id=ec266aa0&scoped=true&"
import script from "./wuHuoQuanTiHuo.vue?vue&type=script&lang=js&"
export * from "./wuHuoQuanTiHuo.vue?vue&type=script&lang=js&"
import style0 from "./wuHuoQuanTiHuo.vue?vue&type=style&index=0&id=ec266aa0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec266aa0",
  null
  
)

export default component.exports